export const font = {
  en: "Montserrat",
  ar: "Cairo",
};
